import React, {useState} from "react";
import {Field, FieldArray} from "formik";
import {get} from "lodash";
import config from "../../../config";
import {Fields} from "@/uicomponents";
import "./form.scss";

const Form = ({
                  isSubmitting,
                  isUpdate,
                  setFieldValue,
                  values,
                  isChat,
                  errors,
                  touched,
                  setSelectedCommit
              }) => {
    return (
        <div className="flex flex-wrap -mx-2.5 !flex-col">
            <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-full max-w-full">
                <Field
                    component={Fields.TextareaS1}
                    name="body"
                    type="text"
                    placeholder="Введите комментарий"
                    label={"Комментарий"}
                    size={"large"}
                />
            </div>
            <div className="!flex !justify-end gap-2">
                {
                    isUpdate &&
                    <button
                        type="button"
                        className={`d-btn d-btn-danger`}
                        onClick={() => setSelectedCommit(null)}
                    >
                        Отмена
                    </button>
                }

                <button
                    type="submit"
                    className={`d-btn d-btn-primary ${isSubmitting ? "--loading" : ""}`}
                    disabled={isSubmitting}
                >
                    {isUpdate ? "Сохранить" : "Добавить"}
                </button>
            </div>
        </div>
    );
};

export default Form;
